import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function Layout({ children }) {
  return (
    <div>
      <Header />
      <main>{children}</main>{" "}
      {/* Main content (where routed components will be rendered) */}
      <Footer />
    </div>
  );
}
